import { KeyRound } from "lucide-react";
import { useTranslation } from "react-i18next";

import { inputVariants } from "@/components/ui/v2/input-variants";
import { cn } from "@/lib/utils/cn";

export function AutoCreatedSecret() {
  const { t } = useTranslation();

  return (
    <div className={cn(inputVariants(), "flex items-center gap-2 text-sm text-muted-foreground")}>
      <KeyRound aria-hidden className="size-4 shrink-0" />
      {t("integrations.modules.configure.fields.autoCreatedSecret")}
    </div>
  );
}
